// extracted by mini-css-extract-plugin
export default {"mood":"ChangeMood_mood__bHOD0","user__title":"ChangeMood_user__title__DZyq1","mood__title":"ChangeMood_mood__title__sUvaQ","mood__list":"ChangeMood_mood__list__8qFZq"};